<template>
  <WsRead
    :modelName="modelName"
    :submodelName="submodelName"
    :modelVersionName="`${modelName}_version`"
    :id="$route.params.id"
    :localeMode="localeMode"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    :modeVersions="modeVersions"
    :parentIsBelongsToMany="false"
    :belongsToChapters="false"
    titleKey="last_version.name"
    :customBtns="_customBtns"
    :hasCatchVersion="hasCatchVersion"
    :itemVersionLinkCreatable="itemVersionLinkCreatable"
    :itemVersionCreatable="itemVersionCreatable"
    :itemVersionReadable="itemVersionReadable"
    :itemEditable="itemEditable"
    :itemLinkCheckable="itemLinkCheckable"
    :itemDeletable="itemDeletable"
    filterName="system_class"
    filterSubName="system_subclass"
    @input="$_getModelData($event)"
  >
  </WsRead>
</template>

<script>
import model from "@/models/change_item_template";
import submodel from "@/models/risk_template";
export default {
  data: () => ({
    modelName: model.modelName,
    submodelName: submodel.modelName,
    label: model.label,
    localeMode: true,
    modeVersions: true,
    fields: model.fields,
    hasCatchVersion: true,
    itemVersionLinkCreatable: false,
    itemVersionCreatable: false,
    itemVersionReadable: false,
    itemEditable: false,
    itemLinkCheckable: true,
    itemDeletable: false,
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          hideOnNull: false,
          floors: [
            {
              title: "變因資訊",
              fields: ["last_version.locales"],
              hideLabelFields: [],
            },
          ],
        },
        {
          type: "expandSystemClass",
          label: submodel.label,
          modelName: submodel.modelName,
          modelTemplateName: submodel.modelName,
          modeParent: true,
          modeParentVersions: true,
          fields: submodel.fields,
          titleKey: "name",
          fieldsRead: submodel.fieldsRead,
          searchMode: false,
          hideOnNull: false,
          expandDisable: true,
          customParentData: (parentData) => {
            let _system_subclass = parentData.last_version.risk_templates.map(
              (mapItem) => {
                return mapItem.system_subclass;
              }
            );
            let _system_class = parentData.last_version.risk_templates.map(
              (mapItem) => {
                return mapItem.system_class;
              }
            );
            return {
              area: parentData.area,
              system_subclass: _system_subclass,
              system_class: _system_class,
              risk_template: parentData.last_version.risk_templates,
            };
          },
        },
      ],
      secondary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "分類設定",
              fields: [
                "areas",
                "industry_categories",
                "last_version.system_classes",
                "last_version.system_subclasses",
                "range_type",
                "factories",
                "exclusive_factories",
              ],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "建立資訊",
              fields: ["created_admin", "created_at"],
            },
          ],
        },
        {
          type: "infoCard",
          floors: [
            {
              title: "編輯資訊",
              fields: ["updated_admin", "updated_at"],
            },
          ],
        },
        {
          type: "activeSwitch",
          title: "顯示設定",
          remark: "隱藏的內容將不會顯示於前端",
          field: "is_active",
        },
      ],
    },
  }),
  computed: {
    _customBtns() {
      return [
        {
          // title: `更新${this.label}版本`,
          title: `更新變因版本`,
          color: "textSecondary",
          outlined: true,
          icon: "mdi-update",
          to: `/${this.modelName}/${this.$route.params.id}/version/update`,
        },
      ];
    },
    _sequenceFields() {
      if (this.modelData) {
        return this.modelData.last_version[`${this.submodelName}s`];
      } else {
        return null;
      }
    },
  },
  methods: {
    $_getModelData($event) {
      this.modelData = $event;
    },
  },
};
</script>